import React from 'react';
import PropTypes from 'prop-types';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ComponentTypesSettings from './ComponentTypesSettings.tsx';

// Create QueryClient at module scope to avoid recreation on each render
const queryClient = new QueryClient();

export default function ComponentTypes({
  supportsSubcomponents,
  hasJointCommission,
  hasServiceTradeIntegration,
  canEditComponentTypes,
  canAddComponentTypes,
  canImportComponentTypes,
  hasDnvReporting,
  dnvTypeOptions,
  translationLanguages
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <ComponentTypesSettings
        supportsSubcomponents={supportsSubcomponents}
        hasJointCommission={hasJointCommission}
        hasServiceTradeIntegration={hasServiceTradeIntegration}
        canEditComponentTypes={canEditComponentTypes}
        canAddComponentTypes={canAddComponentTypes}
        canImportComponentTypes={canImportComponentTypes}
        hasDnvReporting={hasDnvReporting}
        dnvTypeOptions={dnvTypeOptions}
        translationLanguages={translationLanguages}
      />
    </QueryClientProvider>
  );
}

ComponentTypes.propTypes = {
  supportsSubcomponents: PropTypes.bool.isRequired,
  hasJointCommission: PropTypes.bool,
  hasServiceTradeIntegration: PropTypes.bool,
  canEditComponentTypes: PropTypes.bool,
  canAddComponentTypes: PropTypes.bool,
  canImportComponentTypes: PropTypes.bool,
  hasDnvReporting: PropTypes.bool,
  dnvTypeOptions: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })),
  translationLanguages: PropTypes.arrayOf(PropTypes.string)
};

ComponentTypes.defaultProps = {
  hasJointCommission: false,
  hasServiceTradeIntegration: false,
  canEditComponentTypes: false,
  canAddComponentTypes: true,
  canImportComponentTypes: true,
  hasDnvReporting: false,
  dnvTypeOptions: [],
  translationLanguages: []
};
